import { StudentRepository } from '../../api/repository/student';
import type { QltStudent } from '../../api/types';
import { createResourceStore } from './resource-store';

export const useQltStudentStore = createResourceStore<QltStudent>(StudentRepository);
